import React from 'react';
import { motion } from 'framer-motion';

const PageWrapper = ({ children, className, instant = false, ...props }) => {
    // 页面切换动画 variants
    const pageVariants = {
        initial: {
            opacity: instant ? 1 : 0,
            y: instant ? 0 : 20
        },
        in: {
            opacity: 1,
            y: 0
        },
        out: {
            opacity: instant ? 1 : 0,
            y: instant ? 0 : -20
        }
    };

    const pageTransition = {
        type: "tween",
        ease: "anticipate",
        duration: instant ? 0 : 0.5
    };

    return (
        <motion.main
            className={className}
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
            {...props}
        >
            {children}
        </motion.main>
    );
};

export default PageWrapper;